/**
 * Created by vladislav on 28.03.2022
 */

const UnitHighlighter = cc.Node.extend({ 
    ctor: function (mapView, unit, options) {
        this._super();

        this.mapView = mapView;

        mapView.under.addChild(this);
        this._setGlobalZOrder(true);

        this.addUnit(unit);

        if (options.ground !== false) {
            unit.getShape().forEach(function (part) {
                this.createGroundSprite(mapView, unit.x, unit.y, part, options.tutorialGround);
            }, this);

            if (!mapView.map2d.isWaterUnit(unit.x, unit.y) && [FamiliesHelper.ShapeCell, FamiliesHelper.ShapeSquare].indexOf(unit.getShape()) !== -1 && options.highlight !== false) {
                const highlight = new Highlight(unit.x, unit.y, {
                    unit
                });
                const highlightView = new HighlightView(highlight);
                highlightView.setLocalZOrder(0);
                this.addChild(highlightView);
                highlightView.setAlignment(mapView.alignInGrid(unit.x, unit.y));
            }
        }

        if (options.spotlight) {
            const position = mapView.alignInGrid(unit.x, unit.y);
            const spotlight = new cleverapps.Spine(bundles.unit_highlighter.jsons.unit_highlighter_json);
            this.addChild(spotlight);
            spotlight.setAlignment(position);

            const multiCell = unit.findComponent(MultiCell);
            if (multiCell) {
                const centerDelta = multiCell.getCenter();
                spotlight.x += centerDelta.x;
                spotlight.y += centerDelta.y;

                spotlight.setAnimationAndIdleAfter("open2x2", "idle2x2");
            } else {
                spotlight.setAnimationAndIdleAfter("open", "idle");
            }
            cleverapps.effects.fire("merge.unit.highlight");
        }
    },

    createGroundSprite: function (mapView, x, y, part, tutorialGround) {
        const map = mapView.map2d;

        let groundView;

        if (tutorialGround) {
            const isOdd = (x + y) % 2;
            const frame = isOdd ? bundles.unit_highlighter.frames.tutorial_ground : bundles.unit_highlighter.frames.tutorial_ground2;
            if (frame && frame.resolve()) {
                groundView = new cc.Sprite(frame);
            }
        }

        if (!groundView) {
            map.setPointer(x, y);
            const ground = map.getGround(Iso.SAME);
            groundView = ViewReader.parse(ground, map);

            if (!groundView) {
                return;
            }

            groundView.setScale(0.97);
        }

        const position = mapView.alignInGrid(x + part.x, y + part.y);
        groundView.setAlignment(position);
        this.addChild(groundView);
    },

    addUnit: function (unit) {
        this.mapView.map2d.showTile(unit.x, unit.y);

        this.unitView = unit.onGetView();
        this.unitView._setGlobalZOrder(true);
        if (this.unitView.getAdditionalView("ingredients")) {
            this.unitView.getAdditionalView("ingredients")._setGlobalZOrder(true);
            this.unitView.outline(true);
        }
    },

    removeUnit: function () {
        if (this.unitView) {
            this.unitView._setGlobalZOrder(false);
            if (this.unitView.getAdditionalView("ingredients")) {
                this.unitView.getAdditionalView("ingredients")._setGlobalZOrder(false);
            }
            this.unitView = undefined;
        }
    },

    unhighlight: function () {
        this.removeUnit();
        this.removeFromParent();
    }
});